
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getBillList } from '@/api/gcash/account'
import { delObjEmptyKey, parseTime } from '@/utils'
import {
  getCurrentDate,
  dateToSeconds,
  pickerOptions,
  dateToSecondsCurrery,
  getSystemDate,
} from '@/utils/dateTime'

const initDate = getCurrentDate()
@Component({
  name: 'ActionLog',
  components: {},
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    },
  },
})
export default class extends Vue {
  private queryForm: any = {
    start_time: initDate[0],
    end_time: initDate[1],
    type: '',
    ref_no: '',
    account_no: '',
  }
  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  protected pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSecondsCurrery(this.date[0])
      this.queryForm.end_time = dateToSecondsCurrery(this.date[1])
    } else {
      this.date = getSystemDate()
    }
  }
  private date: any[] = getSystemDate()
  private pickerOptions: any = pickerOptions

  private logList: any[] = []
  private listLoading: boolean = false
  private total = 0

  private promptLoading: boolean = false

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      delObjEmptyKey(data)
      await getBillList(data).then((res: any) => {
        this.logList = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.logList = []
      this.listLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      start_time: initDate[0],
      end_time: initDate[1],
      type: '',
      ref_no: '',
      account_no: '',
    }
    // let el:any = this.$refs.myTable
    // el.clearSort()
    this.currentPage = 1
    this.date = getCurrentDate()
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  private changeUnlock() {}

  private async init() {
    await this.hadleGetFilesListApi()
  }

  mounted() {
    this.init()
  }
}
